import React, { PureComponent } from "react";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import cn from "classnames";
import TableCell from "./TableCell";

class TableRow extends PureComponent {
  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage());
  }

  render() {
    const {
      connectDragSource,
      columns,
      row,
      isChecked,
      onCheck,
      isDragging,
      selectable,
    } = this.props;

    return connectDragSource(
      <tr
        ref={connectDragSource}
        className={cn({
          "dnd-table-row": true,
          dragging: isDragging && isChecked,
        })}>
        {selectable && (
          <td style={{ textAlign: "center" }} className="dnd-table-cell">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => onCheck(row.id, isChecked)}
            />
          </td>
        )}
        {columns.map(column => (
          <TableCell
            key={column.title}
            {...column}
            content={row[column.dataField]}
            row={row}
            style={column.style}
          />
        ))}
      </tr>,
    );
  }
}

export default DragSource(
  props => props.type,
  {
    beginDrag: ({
      row,
      onBeginDrag,
      handleImagePreviewShow,
      handleImagePreviewMove,
    }) => {
      handleImagePreviewShow();
      document.addEventListener("dragover", handleImagePreviewMove);
      onBeginDrag(row.id);
      return { id: row.id };
    },

    endDrag: ({
      onEndDrag,
      handleImagePreviewMove,
      handleImagePreviewHide,
    }) => {
      document.removeEventListener("dragover", handleImagePreviewMove);
      handleImagePreviewHide();
      onEndDrag();
    },
  },
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
  }),
)(TableRow);
